module.exports = __webpack_public_path__ + "static/media/freshgrocer-onboarding-shop.70ba8fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer-onboarding-shop.png
// module id = 366
// module chunks = 0